var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-form',{attrs:{"elements":_vm.formElements},model:{value:(_vm.asset),callback:function ($$v) {_vm.asset=$$v},expression:"asset"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }